export const documentById = (documents, documentId) => { if (!documents || documents.length === 0) {
    return null;
} return documents.find(doc => doc.id === documentId && doc.archived_at === null) || null; };
export const documentsByKind = (documents, kindId, subKindId = null, isIncomeKind = false) => { if (!documents || documents.length === 0) {
    return isIncomeKind ? [] : null;
} let filteredDocuments = documents.filter(doc => doc.upload_kind_id === kindId && doc.archived_at === null); if (subKindId && filteredDocuments.length > 0) {
    filteredDocuments = filteredDocuments.filter(doc => doc.upload_sub_kind_id === subKindId);
} return !isIncomeKind ? filteredDocuments[0] : filteredDocuments; };
export const getFileExtension = file => { if (!file || !file.name) {
    return null;
} return file.name.split('.').pop().toLowerCase(); };
export const getStatusData = (documentId, statusName, statusData) => { switch (statusName) {
    case 'not checked': return setData(documentId, 'In Review', 'Your document has been received, ready to be reviewed by your Tax Specialist.', 'positive');
    case 'approved': return setData(documentId, 'Approved', 'Your document has been received and approved.', 'positive');
    case 'failed': return setData(documentId, 'Expired', 'Your document is no longer valid. Please upload a new version.', 'negative');
    case 'review': return setData(documentId, 'Required', statusData.proof_of_address.text, 'warning');
} };
export const getStatusName = (document, uploadStatuses) => { if (!document || !uploadStatuses || uploadStatuses.length === 0) {
    return null;
} const status = uploadStatuses.find(s => s.id === document?.upload_status_id); if (!status || status === undefined) {
    return null;
} return status['name']; };
export const uploadingLabel = count => { return `Uploading ${count} ${count > 1 ? 'files' : 'file'}...`; }; // Private
const setData = (documentId, label, message, modifier) => { return { key: documentId, label: label, message: message, modifier: modifier }; };
